import * as React from 'react';
import * as shortId from 'shortid';
import Tile from './tile';

interface TileWallProps {
    tileObjects: TileObject[];
}

// tslint:disable-next-line:no-empty-interface
interface TileWallState {
    //
}

/* tslint:disable */
export class TileObject {
    tileHead: JSX.Element;
    tileBody: JSX.Element;
    tileFunction?: () => void | undefined;

    constructor(tileHead: JSX.Element, tileBody: JSX.Element, tileFunction?: () => void | undefined) {
        this.tileHead = tileHead;
        this.tileBody = tileBody;
        if (tileFunction !== undefined) {
            this.tileFunction = tileFunction;
        } else {
            this.tileFunction = undefined;
        }
    }
}

//Consecutive blank lines! weeeee!

/* tslint:enable */

class TileWall extends React.PureComponent<TileWallProps, TileWallState> {
    constructor(props: TileWallProps) {
        super(props);
        this.renderTiles = this.renderTiles.bind(this);
    }

    renderTiles(tileObjects: TileObject[]) {
        const arr = Array<any>();
        for (const x of tileObjects) {
            arr.push(
                <Tile
                    key={shortId.generate()}
                    tileHead={x.tileHead}
                    tileBody={x.tileBody}
                    tileFunction={x.tileFunction ? x.tileFunction : undefined}
                />
            );
        }

        return arr;
    }

    public render() {
        return (
            <div>
                <div className="masonry">{this.renderTiles(this.props.tileObjects)}</div>
            </div>
        );
    }
}
export default TileWall;



// WEBPACK FOOTER //
// ./src/components/tileWall/tileWall.tsx